import { render, staticRenderFns } from "./LinkedSaleNo.vue?vue&type=template&id=65c40f0c&scoped=true"
import script from "./LinkedSaleNo.vue?vue&type=script&lang=js"
export * from "./LinkedSaleNo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c40f0c",
  null
  
)

export default component.exports